import { useState } from 'react';
import api from 'service/api';
import { useAuth } from 'hook/auth';

export const useGroupsUser = () => {
  const { requestIntercept } = useAuth();

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const getList = async (params) => {
    try {
      setLoading(true);
      const response = await requestIntercept(api.get, `/v1/groups`, params);
      if (response.status !== 200) {
        throw response;
      }
      setData(response.data.data);
      setTotal(response.data.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getOne = async ({ id }) => {
    try {
      setLoading(true);
      const response = await requestIntercept(api.get, `/v1/groups/${id}`);

      if (response.status !== 200) {
        throw response;
      }
      setData(response.data.data);
      setTotal(response.data.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getCreate = async ({ data }) =>
    new Promise((resolve, reject) => {
      (async () => {
        try {
          setLoading(true);
          const response = await requestIntercept(
            api.post,
            `/v1/groups`,
            data,
            null,
            true
          );
          if (response.status !== 200 && response.status !== 201) {
            throw response;
          }
          setData(response.data.data);
          setTotal(response.data.total);
          setStatus(response.status);
          setTimeout(() => {
            setLoading(false);
          }, 500);
          resolve(response.data.data);
        } catch (error) {
          setLoading(false);
          setStatus(error.status);
          reject(error);
        }
      })();
    });

  const getUpdate = async ({ id, data }) =>
    new Promise((resolve, reject) => {
      (async () => {
        try {
          setLoading(true);
          const response = await requestIntercept(
            api.put,
            `/v1/groups/${id}`,
            data,
            null,
            true
          );
          if (response.status !== 200 && response.status !== 201) {
            throw response;
          }
          setStatus(response.status);
          setTimeout(() => {
            setLoading(false);
          }, 500);
          resolve(response.data.data);
        } catch (error) {
          setLoading(false);
          setStatus(error.status);
          reject(error);
        }
      })();
    });

  const getDelete = async ({ id }) => {
    try {
      setDeleteLoading(true);
      const response = await requestIntercept(api.delete, `/v1/groups/${id}`);
      if (response.status !== 200) {
        throw response;
      }
      setData((oldData) => [...oldData.filter((item) => item.id !== id)]);
      setTotal(total - 1);
      setDeleteLoading(false);
    } catch (error) {
      setDeleteLoading(false);
    }
  };

  const getSyncAgency = async ({ id, data }) =>
    new Promise((resolve, reject) => {
      (async () => {
        try {
          setLoading(true);
          const response = await requestIntercept(
            api.post,
            `/v2/admin/groups/${id}/regulation_agency`,
            data,
            null,
            true
          );
          if (response.status !== 200 && response.status !== 201) {
            throw response;
          }
          setData(response.data.data);
          setTotal(response.data.total);
          setStatus(response.status);
          setTimeout(() => {
            resolve();
            setLoading(false);
          }, 500);
        } catch (error) {
          setLoading(false);
          setStatus(error.status);
          reject(error);
        }
      })();
    });

  const toggleStatus = async ({ id, status, data }) => {
    try {
      const response = await requestIntercept(api.put, `/v1/groups/${id}`, {
        ...data,
        status,
      });
      if (response.status !== 200) {
        throw response;
      }
    } catch (error) {
      // setDeleteLoading(false);
    }
  };

  return {
    data,
    total,
    loading,
    status,
    deleteLoading,
    getList,
    getOne,
    getDelete,
    getCreate,
    getUpdate,
    getSyncAgency,
    toggleStatus,
  };
};
